export const TEXTS = {
    login: {
        label: 'Login',
        goToAuthPageButtonLabel: 'Login with Email and Password',
    },
    signup: {
        label: 'Signup',
        goToAuthPageButtonLabel: 'Signup with Email',
    },
};
